import { gql } from '@apollo/client';

export const ALL_INSIGHTS = gql`
  query AllInsights($input: getInsightsInput!) {
    insights: allInsights(input: $input) {
      id
      name
      tags {
        id
        name
      }
      url
      image
      isFavorite
      width
      height
      createdBy {
        id
        firstName
        lastName
      }
      createdOn
    }
  }
`;
